/**
 * Checks whether a web browser is the Samsung Internet Browser.
 *
 * @returns {boolean}
 */
export function isSamsungBrowser() {
  return navigator.userAgent.includes('SamsungBrowser');
}



// WEBPACK FOOTER //
// ./app/assets/javascripts/utils/browser.js